import g from '#core/global';
import load from '#core/load';
import lazy from '#common/lazy';
import statistic_number from '#element/statistic-number/statistic-number';


const print_attr = 'data-print';
const print_button_$ = `[${print_attr}]`;
const lazy_image_$ = 'img[loading="lazy"]';
const prepare_timeout = 1500;

let is_printing = false;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('print')) return false;
		
		load.content(() => {
			assign_events();
		});
	},
	
	
	/**
	 * Prepare the page, then open the print dialog
	 */
	print() {
		request_print();
	},
	
};

export default module;
module.init();


/**
 * Assign event listeners
 */
function assign_events() {
	
	// Delegated so that print buttons added after load are covered too
	document.addEventListener(g.click_e, e => {
		const $button = e.target.closest(print_button_$);
		if (!$button) return false;
		
		e.preventDefault();
		request_print();
	});
	
	// Route the keyboard shortcut through the same preparation as the button
	document.addEventListener(g.key_down_e, e => {
		if (!e.metaKey && !e.ctrlKey) return false;
		if (!e.key || e.key.toLowerCase() !== 'p') return false;
		
		e.preventDefault();
		request_print();
	});
	
	// Any other route to the dialog (browser menu, a direct window.print call)
	// still gets the media prepared, but cannot be held open while it loads
	window.addEventListener(g.before_print_e, () => {
		prepare_page();
	});
	
}


/**
 * Prepare the page, then open the print dialog. The preparation is capped by a
 * timeout so a slow image can never leave the dialog unopened.
 */
function request_print() {
	if (is_printing) return false;
	is_printing = true;
	
	const timeout = new Promise(resolve => {
		setTimeout(resolve, prepare_timeout);
	});
	
	Promise.race([prepare_page(), timeout]).finally(() => {
		window.print();
		is_printing = false;
	});
}


/**
 * Bring the whole page to the state it would reach if someone scrolled through
 * it, since print takes everything below the fold as it stands
 * @return {Promise}
 */
function prepare_page() {
	const tasks = [];
	
	document.querySelectorAll(lazy_image_$).forEach($image => {
		tasks.push(load_image($image));
	});
	
	statistic_number.finish();
	
	return Promise.all(tasks);
}


/**
 * Load an image now instead of when it scrolls into view
 * @param {element} $image
 * @return {Promise}
 */
function load_image($image) {
	$image.removeAttribute('loading');
	$image.setAttribute('fetchpriority', 'high');
	
	if (lazy.isLoaded($image)) return Promise.resolve();
	
	return new Promise(resolve => {
		$image.addEventListener(g.load_e, resolve, { once: true });
		$image.addEventListener(g.error_e, resolve, { once: true });
	});
}
